import { TD_BLACKBOX } from '@/constant/enum';
import { setSStorage, getSStorage } from 'atour-utils';

const PARTNER = 'yaduo_atat';
const CHANNEL = 'yaduo_atat_h5';
const APPKEY = '42ea9aa6b7acd900de2f0943b1b1928f';

const BASE_URL = 'https://static.trustdecision.com/tdfp/cn/42ea9aa6b7acd900de2f0943b1b1928f/fm.js';
const SCRIPT_ATTR = 'data-tdfp-sdk';
const DEFAULT_TIMEOUT = 3000; // 兜底超时，避免 Promise 悬挂
let __tdfpInitDone = false;

export function tdFpInit() {
    return new Promise((resolve) => {
        // 保证只 resolve 一次
        let settled = false;
        let timerId = null;
        const done = (val) => {
            if (settled) return;
            settled = true;
            if (timerId) clearTimeout(timerId);
            resolve(val);
        };

        const _tdBlackbox = getSStorage(TD_BLACKBOX);
        // 如果已初始化或已拿到 blackbox，则立即返回（可能为 undefined/空串，但不再阻塞）
        if (__tdfpInitDone || _tdBlackbox) {
            return done(_tdBlackbox);
        }

        // 合并/设置全局配置，保留外部自定义 success
        const prevOpt = window._fmOpt || {};
        window._fmOpt = {
            partner: PARTNER,
            appName: CHANNEL,
            channel: CHANNEL,
            appKey: APPKEY,
            ...prevOpt,
            success(data) {
                console.log('blackbox: ', data);
                setSStorage(TD_BLACKBOX, data);
                try { prevOpt.success?.(data); } catch (e) {
                    console.error('tdfp success callback error: ', e);
                }
                done(data);
            },
        };

        // 兜底超时（脚本未能触发 success 时也要 resolve）
        timerId = setTimeout(() => {
            done(_tdBlackbox);
        }, DEFAULT_TIMEOUT);

        // 若脚本标签已存在（通过自定义 data 属性或 src 前缀判断），不再重复插入
        const existed = document.querySelector(`script[${SCRIPT_ATTR}]`) || document.querySelector(`script[src^="${BASE_URL}"]`);
        // 已存在：不重复插入，但保持等待 success 或超时兜底
        if (existed) {
            __tdfpInitDone = true;
            return;
        }

        const fm = document.createElement('script');
        fm.setAttribute(SCRIPT_ATTR, 'true');
        fm.type = 'text/javascript';
        fm.async = true;
        fm.onload = function() {
            __tdfpInitDone = true;
        };
        fm.onerror = function() {
            // 加载失败也不再卡住，直接兜底
            done(_tdBlackbox);
        };
        fm.src = `${BASE_URL}?t=` + (new Date().getTime() / 3600000).toFixed(0);
        const s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(fm, s);
    });
}

export const getTdBlackbox = function() {
    return getSStorage(TD_BLACKBOX) ?? '';
};
